import { Suspense, lazy } from 'react';
import { useRoutes, Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import RequireAuth from '@/components/RequireAuth';
import '@/components/RequireAuth.scss';
import SimpleLayout from '@/layouts/SimpleLayout';

const StockBoard = lazy(() => import('@/pages/StockBoard'));
const Login = lazy(() => import('@/pages/Login'));

export default function Router() {
  const routes = useRoutes([
    {
      path: '/login',
      element: <Login />,
    },
    {
      path: '/',
      element: (
        <RequireAuth>
          <SimpleLayout />
        </RequireAuth>
      ),
      children: [
        { path: '/', element: <StockBoard /> },
        { path: '*', element: <Navigate to="/" replace /> },
      ],
    },
  ]);

  return (
    <Suspense
      fallback={
        <div className="auth-loading">
          <Spin size="large" />
        </div>
      }
    >
      {routes}
    </Suspense>
  );
}
